import { HeroTone } from './heroThemes';

/** Maps a route to the product-area color theme used on canvas, nav, and heroes. */
export function pageToneFromPath(pathname: string): HeroTone {
  const path = (pathname || '/').toLowerCase();

  if (path.startsWith('/admin') || path.startsWith('/owner')) return 'admin';
  if (path.startsWith('/courses') || path.startsWith('/my-courses') || path.startsWith('/my-learning')) return 'courses';
  if (path.startsWith('/labs') || path.startsWith('/my-labs')) return 'labs';
  if (path.startsWith('/projects') || path.startsWith('/my-projects')) return 'projects';
  if (path.startsWith('/programs')) return 'academy';
  if (path.startsWith('/interviews') || path.startsWith('/interviewer')) return 'interviews';
  if (path.startsWith('/events') || path.startsWith('/my-events')) return 'events';
  if (path.startsWith('/gigs') || path.startsWith('/my-gigs')) return 'gigs';
  if (path.startsWith('/mentor')) return 'mentors';
  if (path.startsWith('/contact')) return 'contact';
  if (
    path.startsWith('/login')
    || path.startsWith('/register')
    || path.startsWith('/forgot')
    || path.startsWith('/dashboard')
    || path.startsWith('/profile')
    || path.startsWith('/verify')
    || path.startsWith('/accept-legal')
    || path.startsWith('/terms')
    || path.startsWith('/privacy')
  ) {
    return 'account';
  }

  return 'home';
}
